import React, {useState} from 'react'
import PropTypes from 'prop-types'
import {FormattedMessage} from 'react-intl'
import {
    Button,
    Stack,
    HStack,
    Divider,
    Box
} from '@salesforce/retail-react-app/app/components/shared/ui'
import {useCommerceApi, useAccessToken} from '@salesforce/commerce-sdk-react'
import StoreDescription from './store-item/store-description'
import {useStoreContext} from '../../../contexts/store'
import useTagManager from '../../../hooks/use-tag-manager'

const SelectedStore = ({setStoreDetails, setEditStore, handleClose, setHideNoSearchResults}) => {
    const [loading, setLoading] = useState(false)
    const api = useCommerceApi()
    const tagManager = useTagManager()
    const {getTokenWhenReady} = useAccessToken()
    const {store} = useStoreContext()

    const handleStoreDetails = async () => {
        setLoading(true)
        const token = await getTokenWhenReady()

        const result = await api.shopperStores.getStores({
            parameters: {
                ids: [store.ID]
            },
            headers: {
                Authorization: `Bearer ${token}`
            },
            keepPreviousData: true
        })

        setLoading(false)
        setHideNoSearchResults(false)
        setStoreDetails(result?.data?.[0] || null)
        if (result?.data?.[0]?.name) {
            tagManager.storeDetailsClick(result?.data?.[0]?.name)
        }
    }

    const handleEditStore = () => {
        setEditStore(true)
        setHideNoSearchResults(true)
    }

    return (
        <Stack gap="15px" divider={<Divider borderColor="gray.550" marginY="0 !important" />}>
            <Stack gap="6px">
                <StoreDescription store={store} />

                <HStack justifyContent="space-between" gap="10px">
                    <Button
                        onClick={handleStoreDetails}
                        isLoading={loading}
                        variant="linkUnderline"
                        fontSize="15px"
                        fontWeight="300"
                        lineHeight="20px"
                        letterSpacing="0.5px"
                        color="black.100"
                    >
                        <FormattedMessage
                            id="select_store_modal.store_details"
                            defaultMessage="Store Details"
                        />
                    </Button>

                    <Button
                        onClick={handleEditStore}
                        variant="linkUnderline"
                        fontSize="15px"
                        fontWeight="300"
                        lineHeight="20px"
                        letterSpacing="0.5px"
                        color="black.100"
                    >
                        <FormattedMessage
                            id="select_store_modal.edit_store"
                            defaultMessage="Edit Store"
                        />
                    </Button>
                </HStack>
            </Stack>

            <Box textAlign="center" paddingTop="5px">
                <Button
                    onClick={handleClose}
                    size="normal"
                    minWidth="227px"
                    height="50px"
                    paddingX="50px"
                    borderRadius="90px"
                    textTransform="uppercase"
                    fontSize="14px"
                    fontWeight="700"
                    lineHeight="20px"
                    letterSpacing="1.2px"
                    color="white"
                    background="black.300 !important"
                    border="none"
                    _hover={{
                        background: 'black.50 !important'
                    }}
                    _active={{
                        background: 'black.50 !important'
                    }}
                    _focus={{
                        background: 'black.50 !important'
                    }}
                >
                    <FormattedMessage
                        id="select_store_modal.continue_shopping"
                        defaultMessage="Continue Shopping"
                    />
                </Button>
            </Box>
        </Stack>
    )
}

SelectedStore.propTypes = {
    setStoreDetails: PropTypes.func.isRequired,
    setEditStore: PropTypes.func.isRequired,
    setHideNoSearchResults: PropTypes.func.isRequired,
    handleClose: PropTypes.func.isRequired
}

export default SelectedStore
